import AxiosClient from "../../../services/axios.services";

class CompetenciesDescServices {
  getCompetenciesDesc = params =>
    AxiosClient.get("/api/app/descriptor_perfil_competencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getCompetencieDescById = id =>
    AxiosClient.get(`/api/app/descriptor_perfil_competencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCompetencieDesc = req =>
    AxiosClient.post("/api/app/descriptor_perfil_competencia/", req, {
      headers: { "Content-Type": "application/json" },
    });
  editCompetencieDesc = (id, req) =>
    AxiosClient.put(
      `/api/app/descriptor_perfil_competencia/${id}/`,
      req,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteCompetencieDesc = id =>
    AxiosClient.delete(`/api/app/descriptor_perfil_competencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CompetenciesDescServices();
